import React, { useCallback, useMemo, type ComponentProps } from "react";

import { cn } from "@/lib/chillnn/cn";

import { Button } from "@/components/ui/button/button";

type Props = {
	children: React.ReactNode;

	canRemoveItem?: boolean;
	reasonForCannotRemoveItem?: string;
	removeItem: () => void;
} & ComponentProps<"div">;

export const QuestionCardItem = React.forwardRef<HTMLDivElement, Props>(
	({ children, removeItem, canRemoveItem = true, reasonForCannotRemoveItem = "", className, ...props }, ref) => {
		const handleClick = useCallback(() => {
			removeItem();
		}, [removeItem]);

		const variant: ComponentProps<typeof Button>["variant"] = useMemo(
			() => (canRemoveItem ? "outline" : "disabled"),
			[canRemoveItem],
		);

		const tooltip = useMemo(
			() => (canRemoveItem ? "" : reasonForCannotRemoveItem),
			[canRemoveItem, reasonForCannotRemoveItem],
		);

		return (
			<div
				className={cn(
					"relative flex w-full flex-col gap-y-4 rounded border border-zinc-200 bg-white px-4 py-12",
					className,
				)}
				ref={ref}
				{...props}
			>
				<span className="absolute right-4 top-4">
					<Button variant={variant} type={"button"} onClick={handleClick} size={"sm"} tooltip={tooltip}>
						削除
					</Button>
				</span>

				{children}
			</div>
		);
	},
);
